(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsObs(
            module.exports
        );

    } else {
        RivalIQ.module('enums');

        enumsObs(
            RivalIQ.enums
        );
    }

    function enumsObs(exports) {
        exports.metricTimePeriods = {
            CURRENT: 0,
            RELATIVE_CHANGE: 1,
            ABSOLUTE_CHANGE: 2
        };

        exports.observationType = {
            totalReach: {
                RANK_TOTAL_REACH_LEADER: 1,
                RANK_TOTAL_REACH_ABOVE_AVERAGE: 2,
                RANK_TOTAL_REACH_BELOW_AVERAGE: 3,
                MISSING_CHANNEL_TWITTER: 4,
                MISSING_CHANNEL_FACEBOOK: 5,
                RANK_TOTAL_REACH_GROWTH_LEADER: 8,
                RANK_TOTAL_REACH_GROWTH_ABOVE_AVERAGE: 9,
                RANK_TOTAL_REACH_GROWTH_BELOW_AVERAGE: 10,
                MISSING_ALL_CHANNELS: 11,
                MISSING_CHANNEL_YOUTUBE: 12,
                MISSING_CHANNEL_INSTAGRAM: 13

            },
            socialActivityEngagement: {
                RANK_INTERACTIONS_LEADER: 100,
                RANK_INTERACTIONS_ABOVE_AVERAGE: 101,
                RANK_INTERACTIONS_BELOW_AVERAGE: 102,
                MISSING_CHANNEL: 103,
                LOW_ACTIVITY: 104,
                NO_ACTIVITY: 105,
                GROWTH: 106,
                INCOMPLETE_DATA: 107
            },
            web: {
                META_DESCRIPTION_MISSING: 400,
                META_DESCRIPTION_TOO_SHORT: 401,
                META_DESCRIPTION_TOO_LONG: 402,
                META_DESCRIPTION_JUST_RIGHT: 403,

                HOMEPAGE_TITLE_MISSING: 404,
                HOMEPAGE_TITLE_TOO_SHORT: 405,
                HOMEPAGE_TITLE_TOO_LONG: 406,
                HOMEPAGE_TITLE_JUST_RIGHT: 407,

                META_KEYWORDS_PRESENT: 408
            },
            socialReach: {
                RANK_SOCIAL_REACH_LEADER: 500,
                RANK_SOCIAL_REACH_ABOVE_AVERAGE: 501,
                RANK_SOCIAL_REACH_BELOW_AVERAGE: 502,
                RANK_SOCIAL_REACH_GROWTH_LEADER: 503,
                RANK_SOCIAL_REACH_GROWTH_ABOVE_AVERAGE: 504,
                RANK_SOCIAL_REACH_GROWTH_BELOW_AVERAGE: 505
            }
        };
    }
})();
